import {defineStore} from "pinia";
import {ref,reactive} from "vue";
import {getSysDictDataList, getSystemOptionList} from "@/apis/system-data";

// 数据字典数据表 列表
const sysDictData = ref([]);


const userGenderList = ref([])
const userStatusList = ref([])
const projectTaskStatusList = ref([])
const projectServiceStatusList = ref([])
const projectServiceIsOvertimeList = ref([])
const projectServiceExceptionStatusList = ref([])
const projectServiceTypeList = ref([])
const projectServiceTaskCategoryList = ref([])
const projectServiceFrequencyList = ref([])
// 项目服务单-建议时间 次/周
const projectServiceSuggestedTimeList_2 = ref([])
// 项目服务单-建议时间 次/月
const projectServiceSuggestedTimeList_3 = ref([])
// 项目服务单-建议时间 次/季
const projectServiceSuggestedTimeList_4 = ref([])
const workOrderInfoWorkStatusList = ref([])
const workOrderInfoTaskTypeList = ref([])
const workOrderInfoWorkCategoryList = ref([])
const workOrderInfoWorkorderTypeList = ref([])
const workOrderApprovalStatusList = ref([])

const userGenderMap = ref(new Map())
const userStatusMap = ref(new Map())
const projectTaskStatusMap = ref(new Map())
const projectServiceStatusMap = ref(new Map())
const projectServiceIsOvertimeMap = ref(new Map())
const projectServiceExceptionStatusMap = ref(new Map())
const projectServiceTypeMap = ref(new Map())
const projectServiceTaskCategoryMap = ref(new Map())
const projectServiceFrequencyMap = ref(new Map())
// 项目服务单-建议时间 次/周
const projectServiceSuggestedTimeMap_2 = ref(new Map())
// 项目服务单-建议时间 次/月
const projectServiceSuggestedTimeMap_3 = ref(new Map())
// 项目服务单-建议时间 次/季
const projectServiceSuggestedTimeMap_4 = ref(new Map())
const workOrderInfoWorkStatusMap = ref(new Map())
const workOrderInfoTaskTypeMap = ref(new Map())
const workOrderInfoWorkCategoryMap = ref(new Map())
const workOrderInfoWorkorderTypeMap = ref(new Map())
const workOrderApprovalStatusMap = ref(new Map())

const systemOptions = reactive({});

//工单状态
const workStatusList = ref([]);
const checkinStatusList = ref([]);
const checkinStatusMap = ref(new Map())
export const useSystemOptionsStore = defineStore('systemOption', () => {
    const initSystemOptions = () => {
        getSystemOptionList().then((res) => {
            systemOptions.value = res.data;
            workStatusList.value = systemOptions.value['workStatusList'];
            checkinStatusList.value = systemOptions.value['checkinStatusList'];
            checkinStatusMap.value = new Map(checkinStatusList.value.map(item => [item.code, item]));
        });
    };
    return {
        // 初始化所有系统选项
        initSystemOptions,
        // 获取系统选项
        systemOptions,
        // 工单状态
        workStatusList,
        // 签到状态
        checkinStatusList,
        checkinStatusMap
    }
})

export const useSysDictDataStore = defineStore('sysDictData', () => {
    const initSysDictData = () => {
        getSysDictDataList().then((res) => {
            sysDictData.value = res.data;
            handleAllMap()
        });
    };
    return {
        // 初始化所有基础数据
        initSysDictData,
        sysDictData,

        // 用户/账户-性别
        userGenderList,
        userGenderMap,
        // 用户状态
        userStatusList,
        userStatusMap,
        // 项目任务单-项目状态
        projectTaskStatusList,
        projectTaskStatusMap,
        // 项目服务单-服务状态
        projectServiceStatusList,
        projectServiceStatusMap,
        // 项目服务单-强制协同
        projectServiceIsOvertimeList,
        projectServiceIsOvertimeMap,
        // 项目服务单异常记录-异常状态
        projectServiceExceptionStatusList,
        projectServiceExceptionStatusMap,
        // 项目服务单-服务类型
        projectServiceTypeList,
        projectServiceTypeMap,
        // 项目服务单-任务单类型
        projectServiceTaskCategoryList,
        projectServiceTaskCategoryMap,
        // 项目服务单-服务频次
        projectServiceFrequencyList,
        projectServiceFrequencyMap,
        // 项目服务单-建议时间  次/周、次/月、次/季
        projectServiceSuggestedTimeList_2,
        projectServiceSuggestedTimeList_3,
        projectServiceSuggestedTimeList_4,
        projectServiceSuggestedTimeMap_2,
        projectServiceSuggestedTimeMap_3,
        projectServiceSuggestedTimeMap_4,
        // 工单信息总表-工单状态
        workOrderInfoWorkStatusList,
        workOrderInfoWorkStatusMap,
        // 工单信息总表-任务类型
        workOrderInfoTaskTypeList,
        workOrderInfoTaskTypeMap,
        // 工单信息总表-工作类别
        workOrderInfoWorkCategoryList,
        workOrderInfoWorkCategoryMap,
        // 工单信息总表-工单类型
        workOrderInfoWorkorderTypeList,
        workOrderInfoWorkorderTypeMap,
        // 工单审批记录-状态
        workOrderApprovalStatusList,
        workOrderApprovalStatusMap
    }
})

function handleAllMap() {
    handleUserGender()
    handleUserStatus()
    handleProjectTaskStatus()
    handleProjectServiceStatus()
    handleProjectServiceIsOvertime()
    handleProjectServiceExceptionStatus()
    handleProjectServiceType()
    handleProjectServiceTaskCategory()
    handleProjectServiceFrequency()
    // 项目服务单-建议时间 次/周、次/月、次/季
    handleProjectServiceSuggestedTime_2()
    handleProjectServiceSuggestedTime_3()
    handleProjectServiceSuggestedTime_4()
    handleWorkOrderInfoWorkStatus()
    handleWorkOrderInfoTaskType()
    handleWorkOrderInfoWorkCategory()
    handleWorkOrderInfoWorkorderType()
    handleWorkOrderApprovalStatus()
}

function handleUserGender() {
    let filter = sysDictData.value.filter(item => item.typeId === '7');
    userGenderList.value = filter;
    // 从sysDictData中获取数据
    userGenderMap.value = new Map(filter.map(item => [item.dictValue, item]));
}

function handleUserStatus() {
    let filter = sysDictData.value.filter(item => item.typeId === '9');
    userStatusList.value = filter;
    // 从sysDictData中获取数据
    userStatusMap.value = new Map(filter.map(item => [item.dictValue, item]));
}

function handleProjectTaskStatus() {
    let filter = sysDictData.value.filter(item => item.typeId === '11');
    projectTaskStatusList.value = filter;
    // 从sysDictData中获取数据
    projectTaskStatusMap.value = new Map(filter.map(item => [item.dictValue, item]));
}

function handleProjectServiceStatus() {
    let filter = sysDictData.value.filter(item => item.typeId === '14');
    projectServiceStatusList.value = filter;
    // 从sysDictData中获取数据
    projectServiceStatusMap.value = new Map(filter.map(item => [item.dictValue, item]));
}

function handleProjectServiceIsOvertime() {
    let filter = sysDictData.value.filter(item => item.typeId === '12');
    projectServiceIsOvertimeList.value = filter;
    // 从sysDictData中获取数据
    projectServiceIsOvertimeMap.value = new Map(filter.map(item => [item.dictValue, item]));
}

function handleProjectServiceExceptionStatus() {
    let filter = sysDictData.value.filter(item => item.typeId === '13');
    projectServiceExceptionStatusList.value = filter;
    // 从sysDictData中获取数据
    projectServiceExceptionStatusMap.value = new Map(filter.map(item => [item.dictValue, item]));
}

function handleProjectServiceType() {
    let filter = sysDictData.value.filter(item => item.typeId === '5');
    projectServiceTypeList.value = filter;
    // 从sysDictData中获取数据
    projectServiceTypeMap.value = new Map(filter.map(item => [item.dictValue, item]));
}

function handleProjectServiceTaskCategory() {
    let filter = sysDictData.value.filter(item => item.typeId === '6');
    projectServiceTaskCategoryList.value = filter;
    // 从sysDictData中获取数据
    projectServiceTaskCategoryMap.value = new Map(filter.map(item => [item.dictValue, item]));
}

function handleProjectServiceFrequency() {
    let filter = sysDictData.value.filter(item => item.typeId === '18');
    projectServiceFrequencyList.value = filter;
    // 从sysDictData中获取数据
    projectServiceFrequencyMap.value = new Map(filter.map(item => [item.dictValue, item]));
}

function handleProjectServiceSuggestedTime_2() {
    let filter = sysDictData.value.filter(item => item.typeId === '19');
    projectServiceSuggestedTimeList_2.value = filter;
    // 从sysDictData中获取数据
    projectServiceSuggestedTimeMap_2.value = new Map(filter.map(item => [item.dictValue, item]));
}

function handleProjectServiceSuggestedTime_3() {
    let filter = sysDictData.value.filter(item => item.typeId === '20');
    projectServiceSuggestedTimeList_3.value = filter;
    // 从sysDictData中获取数据
    projectServiceSuggestedTimeMap_3.value = new Map(filter.map(item => [item.dictValue, item]));
}

function handleProjectServiceSuggestedTime_4() {
    let filter = sysDictData.value.filter(item => item.typeId === '21');
    projectServiceSuggestedTimeList_4.value = filter;
    // 从sysDictData中获取数据
    projectServiceSuggestedTimeMap_4.value = new Map(filter.map(item => [item.dictValue, item]));
}

function handleWorkOrderInfoWorkStatus() {
    let filter = sysDictData.value.filter(item => item.typeId === '10');
    workOrderInfoWorkStatusList.value = filter;
    // 从sysDictData中获取数据
    workOrderInfoWorkStatusMap.value = new Map(filter.map(item => [item.dictValue, item]));
}

function handleWorkOrderInfoTaskType() {
    let filter = sysDictData.value.filter(item => item.typeId === '15');
    workOrderInfoTaskTypeList.value = filter;
    // 从sysDictData中获取数据
    workOrderInfoTaskTypeMap.value = new Map(filter.map(item => [item.dictValue, item]));
}

function handleWorkOrderInfoWorkCategory() {
    let filter = sysDictData.value.filter(item => item.typeId === '16');
    workOrderInfoWorkCategoryList.value = filter;
    // 从sysDictData中获取数据
    workOrderInfoWorkCategoryMap.value = new Map(filter.map(item => [item.dictValue, item]));
}

function handleWorkOrderInfoWorkorderType() {
    let filter = sysDictData.value.filter(item => item.typeId === '17');
    workOrderInfoWorkorderTypeList.value = filter;
    // 从sysDictData中获取数据
    workOrderInfoWorkorderTypeMap.value = new Map(filter.map(item => [item.dictValue, item]));
}

function handleWorkOrderApprovalStatus() {
    let filter = sysDictData.value.filter(item => item.typeId === '8');
    workOrderApprovalStatusList.value = filter;
    // 从sysDictData中获取数据
    workOrderApprovalStatusMap.value = new Map(filter.map(item => [item.dictValue, item]));
}